import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {CurrencyService} from '../../../services/currency-service';
import {environment} from '../../../../environments/environment';
import {ReportService} from '../../../services/report.service';
import {TransactionService} from '../../../services/transaction.service';
import {TransactionSpanDTO} from '../../../model/transactionSpanDTO';
import {SummaryDTO} from '../../../model/summaryDTO';

@Component({
  styleUrls: ['./confirm-download-final-dialog.component.scss'],
  templateUrl: './confirm-download-final-dialog.component.html'
})

export class ConfirmDownloadFinalDialogComponent implements OnInit {

  @ViewChild('stepper') stepper: MatStepper;
  pdfSource;
  checks = [];
  isLoading;

  totalPages = 1;
  allPagesViewed = false;
  currentPreviewPage: any;
  progress: any;
  currentHighestPage = 0;
  summary: SummaryDTO;
  hasOtherTransactions: boolean;
  transactionSpans: TransactionSpanDTO[];

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              public dialogRef: MatDialogRef<ConfirmDownloadFinalDialogComponent>,
              public service: ReportService,
              private transactionService: TransactionService,
              public currencyService: CurrencyService) {
  }

  ngOnInit(): void {
    this.setChecks();
    this.service.getSummary(this.data.clientId, this.data.type, this.data.year).subscribe(summary => this.summary = summary);
    if (!(this.data.type === 'BB' || this.data.type === 'VJE')) {
      console.log(this.data);
      this.transactionService.hasOtherTransactions(this.data.type, this.data.clientId, this.data.year).subscribe(hasOtherTransactions => this.hasOtherTransactions = hasOtherTransactions);
      this.transactionService.getTransactionSpans(this.data.type, this.data.clientId, this.data.year).subscribe(transactionSpans => this.transactionSpans = transactionSpans);
    }
  }

  private setChecks() {
    this.checks.push({value: false, label: 'Ik heb het concept rapport gecontroleerd op onjuistheden.'});
    if (!(this.data.type === 'BB' || this.data.type === 'VJE')) {
      console.log(this.data.type);
      this.checks.push({value: false, label: 'Ik heb de transacties over de gehele periode waarover de rekening en verantwoording gemaakt dient te worden geimporteerd en gecategoriseerd.'});
    }
    this.checks.push({value: false, label: 'Ik ben mij ervan bewust dat ik eindverantwoordelijk ben voor het aanleveren van een juist en volledig rapport.'});
  }

  sure() {
    if (this.summary && this.summary.deviation === 0) {
      this.toPreview();
    } else {
      this.stepper.next();
    }
  }

  downloadFinal() {
    if (this.isLoading) return;
    this.isLoading = true;
    this.dialogRef.disableClose = true;
    this.data.downloadFinal().then(() => {
      this.stepper.next();
      this.isLoading = false;
    });
  }

  allChecked() {
    return this.checks.filter(check => !check.value).length === 0;
  }

  afterLoadComplete($event) {
    this.totalPages = $event.numPages;
  }

  pageChange(page: number) {
    if (page > this.currentHighestPage) {
      this.currentHighestPage = page;
      this.progress = this.currentHighestPage / this.totalPages * 100;
    }
    if (!this.allPagesViewed && page === this.totalPages) {
      this.allPagesViewed = true;
    }
  }

  euro(value) {
    return this.currencyService.symbol('EUR') + this.currencyService.format(value);
  }

  toPreview() {
    this.service.generatePreviewKey(this.data.clientId, this.data.type, this.data.year).subscribe(key => {
      this.pdfSource = environment.baseUrl + environment.apiPrefix + 'report/preview/' + key.previewKey;
      this.stepper.next();
    });
  }
}
